import { render, staticRenderFns } from "./pessoa-fisica.vue?vue&type=template&id=e1e52f90&"
import script from "./pessoa-fisica.vue?vue&type=script&lang=js&"
export * from "./pessoa-fisica.vue?vue&type=script&lang=js&"
import style0 from "./pessoa-fisica.vue?vue&type=style&index=0&id=e1e52f90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports